import React from "react";
import ReactDOM from "react-dom";
import { Modal, Icon, Button } from "antd";
import { ModalProps, ModalFunc, ModalFuncProps } from "antd/lib/modal/Modal";
import "./MsModal.scss";

/**
 * 共同Modal
 * 限制了浏览器后退按钮
 *
 * @class MsModal
 * @extends {React.Component<ModalProps>}
 */
class MsModal extends React.Component<ModalProps> {
  public static confirm: ModalFunc;
  public static info: ModalFunc;
  public static success: ModalFunc;
  public static error: ModalFunc;
  public static warning: ModalFunc;

  // 第一次渲染后
  public componentDidMount() {
    window.addEventListener("popstate", this.onWindowPopstate);
    this.onWindowPopstate();
  }

  // 卸载组件前
  public componentWillUnmount() {
    window.removeEventListener("popstate", this.onWindowPopstate);
  }

  // 渲染
  public render() {
    let className = "ms-modal-default"
    if (this.props.className) {
      className = `${className} ${this.props.className}`;
    }
    return <Modal {...this.props} className={ className } maskClosable={false} />
  }

  // 后退限制
  private onWindowPopstate = () => {
    if (window.history && window.history.pushState) {
      window.history.pushState(null, document.title, location.href);
      window.history.forward();
    }
  }
}

MsModal.confirm = (props: ModalFuncProps) => {
  const config = {
    type: "confirm",
    iconType: "exclamation-circle",
    title: "确认",
    ...props,
  };
  return confirm(config);
};

MsModal.info = (props: ModalFuncProps) => {
  const config = {
    type: "info",
    iconType: "info-circle",
    title: "提示",
    ...props,
  };
  return confirm(config);
};

MsModal.success = (props: ModalFuncProps) => {
  const config = {
    type: "success",
    iconType: "check-circle",
    title: "成功",
    ...props,
  };
  return confirm(config);
};

MsModal.error = (props: ModalFuncProps) => {
  const config = {
    type: "error",
    iconType: "close-circle",
    title: "错误",
    ...props,
  };
  return confirm(config);
};

MsModal.warning = (props: ModalFuncProps) => {
  const config = {
    type: "warning",
    iconType: "exclamation-circle",
    title: "警告",
    ...props
  };
  return confirm(config);
};

function confirm(this: any, config: ModalFuncProps) {
  const div = document.createElement('div');
  document.body.appendChild(div);

  const title = <div style={ {width: "100%", textAlign: "center", fontSize: 22} }>
    <Icon type={ config.iconType || "question-circle" } className={ `${config.type}-color` } style={ {marginRight: 12} } theme="filled" />
    { config.title }
  </div>;
  const body = <div style={ {width: "100%", textAlign: "center"} }>
    { config.content }
  </div>
  const buttonStyles = {width: 110, height: 35};
  const footer = <div style={ {width: "100%", textAlign: "center"} }>
    { config.type === "conform" ? <Button key="back" style={ {...buttonStyles} }>取消</Button> : null }
    <Button onClick={ close.bind(this, {triggerOk: true}) } style={ {...buttonStyles, marginLeft: 20} } type="primary">
      确定
    </Button>
  </div>;

  let currentConfig = {
    ...config,
    close,
    title,
    visible: true,
    maskClosable: false,
    closable: false,
    bodyStyle: {textAlign: "center"},
    footer,
    className: "ms-modal-confirm-default"
  } as any;
  function close(this: any, ...args: any[]) {
    currentConfig = {
      ...currentConfig,
      visible: false,
      afterClose: destroy.bind(this, ...args),
    };
    render(currentConfig);
  }
  function update(newConfig: ModalFuncProps) {
    currentConfig = {
      ...currentConfig,
      ...newConfig,
    };
    render(currentConfig);
  }
  function destroy(...args: any[]) {
    const unmountResult = ReactDOM.unmountComponentAtNode(div);
    if (unmountResult && div.parentNode) {
      div.parentNode.removeChild(div);
    }
    const triggerOk = args.some(param => param && param.triggerOk);
    if (config.onOk && triggerOk) {
      config.onOk(...args);
    }
  }
  function render(props: any) {
    ReactDOM.render(<Modal {...props}>{ body }</Modal>, div);
  }
  render(currentConfig);
  return {
    destroy: close,
    update,
  };
}

export default MsModal;



// WEBPACK FOOTER //
// ./src/components/ms-common/ms-modal/MsModal.tsx